'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Actions = require('../../Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _ScheduleScreenStore = require('../../stores/ScheduleScreenStore');

var _ScheduleScreenStore2 = _interopRequireDefault(_ScheduleScreenStore);

var _CartStore = require('../../stores/CartStore');

var _CartStore2 = _interopRequireDefault(_CartStore);

var _MainStore = require('../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

var _reflux = require('reflux');

var _reflux2 = _interopRequireDefault(_reflux);

var _itemOptions = require('../item-options');

var _itemOptions2 = _interopRequireDefault(_itemOptions);

var _ItemOptionModal = require('../generic/ItemOptionModal');

var _ItemOptionModal2 = _interopRequireDefault(_ItemOptionModal);

var _Utility = require('../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _SimpleButton = require('../generic/SimpleButton');

var _SimpleButton2 = _interopRequireDefault(_SimpleButton);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _Constants = require('../Constants');

var Constants = _interopRequireWildcard(_Constants);

var _reactRouterDom = require('react-router-dom');

var _SpinButton = require('../generic/SpinButton');

var _SpinButton2 = _interopRequireDefault(_SpinButton);

var _emptyImg = require('../../../img/empty-img.png');

var _emptyImg2 = _interopRequireDefault(_emptyImg);

var _sweetalert = require('sweetalert2');

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//wrapper functional component to pass params as props to main file.
function withCartItemsRouter(Component) {
    function ComponentWithCartItemsRouter(props) {
        var history = (0, _reactRouterDom.useHistory)();
        var params = (0, _reactRouterDom.useParams)();
        return _react2.default.createElement(Component, _extends({}, props, { history: history, params: params /* other hooks */ }, {
            params: params

        }));
    }
    return ComponentWithCartItemsRouter;
}

var CartItems = (0, _createReactClass2.default)({
    displayName: 'CartItems',


    // contextTypes : {
    //     router : React.PropTypes.object.isRequired
    // },

    mixins: [_reflux2.default.listenTo(_CartStore2.default, 'onChange')],

    getInitialState: function getInitialState() {
        return {
            cartBuffer: [],
            imageURL: "",
            view: {
                showItemOptionModal: false
            }
        };
    },
    UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
        this.setState({
            cartBuffer: _CartStore2.default.getCartItems(),
            item: _ScheduleScreenStore2.default.getScheduledItem()
        });
    },
    componentDidMount: function componentDidMount() {
        // this.handleCartRightHeight();
    },
    onChange: function onChange(event, _cart) {
        var _this = this;

        this.setState({
            cartBuffer: _cart
        }, function () {
            if (_this.state.cartBuffer.length === 0) {

                var locId = _this.props.params.locId;
                var history = _this.props.history;

                // Navigate to Another Component

                history.push({
                    pathname: "/location/" + locId,
                    resetStore: false
                });
            }
        });
    },
    generateChosenOptionsList: function generateChosenOptionsList(chosenOptions, optionsContainer) {
        var res = chosenOptions.map(function (cOption) {
            var key = cOption.category;
            var idx = _.findIndex(optionsContainer, function (option) {
                return option.category.trim() == key.trim();
            });

            var coKeyVal = cOption.selectedKeys.reduce(function (acc, key) {
                acc[key] = (acc[key] || 0) + 1;
                return acc;
            }, {});

            return Object.keys(coKeyVal).map(function (key, i) {
                var price = "";
                var optionPrefix = "";

                if (optionsContainer[idx].options) {
                    var optionObject = optionsContainer[idx].options.find(function (x) {
                        return _.keys(x)[0] === key;
                    });
                    price = optionObject[key].price == 0 ? '' : '$' + optionObject[key].price;
                } else if (optionsContainer[idx][key] !== 0) {
                    price = '$' + optionsContainer[idx][key];
                }

                if (coKeyVal[key] > 1) {
                    optionPrefix = ': ' + coKeyVal[key] + ' ';
                    if (price !== "") {
                        optionPrefix = optionPrefix + " x ";
                    }
                } else {
                    if (price !== "") {
                        optionPrefix = ': ';
                    }
                }

                return _react2.default.createElement(
                    'li',
                    {
                        key: key + '-' + i + '-' + idx,
                        className: 'item-options'
                    },
                    key,
                    optionPrefix,
                    price
                );
            });
        });
        return _react2.default.createElement(
            'ul',
            { className: 'list-unstyled' },
            res
        );
    },
    updateItemInCart: function updateItemInCart(e, itemIndex, actualItem) {
        e.preventDefault();
        var currentItemInCart = this.state.cartBuffer[itemIndex];
        this.editCurrentItemInCart(actualItem, itemIndex, currentItemInCart);
    },
    editCurrentItemInCart: function editCurrentItemInCart(actualItem, itemIndexInCart, itemInCart) {
        var _this2 = this;

        Utils.showSpinner();
        setTimeout(function () {
            Utils.hideSpinner();
            _this2.setState({
                item: actualItem,
                itemIndexInCart: itemIndexInCart,
                itemInCart: itemInCart,
                cartNewItem: true,
                imageAvailable: false,
                view: {
                    showItemOptionModal: true
                }
            }, function () {
                var imageLink = _this2.getImageLink(_this2.state.item);
                // this.setItemImage(imageLink);

                if (!_this2.props.isMobile) {
                    _this2.props.callBackParent(_this2.state.view.showItemOptionModal);
                }
            });
        }, 500);
    },
    removeItemFromCart: function removeItemFromCart(event, itemIndex) {
        event.stopPropagation();
        if (!_CartStore2.default.getCartCount() == 0) {

            _sweetalert2.default.fire({
                title: "Are you sure ?",
                text: "Do you want to remove this item from cart?",
                icon: 'warning',
                showCancelButton: true,
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                customClass: {
                    confirmButton: "bg-styl",
                    cancelButton: "swal2-confirm custom-btn-outline-primary custom-primary"
                },
                allowOutsideClick: false

            }).then(function (result) {
                if (result.isConfirmed) {
                    Utils.showSpinner();
                    setTimeout(function () {
                        Utils.hideSpinner();
                        _Actions2.default.removeItemFromCart(itemIndex);
                    }, 500);
                }
            });
        }
    },


    // handleCartRightHeight(){
    //     var element = document.getElementById("cart-struct");
    //
    //     if (typeof(element) != 'undefined' && element != null) {
    //
    //         var elemHgt = element.clientHeight;
    //         if(elemHgt >= 630){
    //             element.classList.add("checkOut-right-old");
    //             element.classList.remove("checkOut-right");
    //             // element.scrollTop =  element.scrollHeight;
    //         }else{
    //             element.classList.add("checkOut-right");
    //             element.classList.remove("checkOut-right-old");
    //         }
    //     }
    //
    // },


    renderCartRow: function renderCartRow() {
        var _this3 = this;

        var self = this;
        return this.state.cartBuffer.map(function (cartItem, index, array) {

            var actualItem = _CartStore2.default.getActualItem(cartItem.itemObjectId);

            return _react2.default.createElement(
                'tr',
                {
                    key: cartItem.itemObjectId + index
                },
                _react2.default.createElement(
                    'td',
                    { className: 'col-12 table-td' },
                    _react2.default.createElement(
                        'div',
                        { className: "row" },
                        _react2.default.createElement(
                            'div',
                            { className: "col-2 col-sm-1 col-md-1 col-lg-1 text-left nopadding" },
                            _react2.default.createElement(
                                'h4',
                                { className: 'item-in-cart' },
                                cartItem.itemQty
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: "col-10 col-sm-11 col-md-11 col-lg-11 nopadding" },
                            _react2.default.createElement(
                                'div',
                                { className: "row" },
                                _react2.default.createElement(
                                    'div',
                                    { className: "col-7 col-sm-9 col-md-9 col-lg-9 pull-left nopadding" },
                                    _react2.default.createElement(
                                        'h4',
                                        { className: 'item-in-cart' },
                                        actualItem.itemName
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    {
                                        className: "col-5 col-sm-3 col-md-3 col-lg-3 pull-right nopadding" },
                                    _react2.default.createElement(
                                        'h4',
                                        {
                                            className: 'item-in-cart cart_subtotal pull-right mt-n1' },
                                        '$',
                                        _.round(cartItem.itemPrice * cartItem.itemQty, 2).toFixed(2)
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    {
                                        className: 'pull-left nopadding ' + (!_this3.props.isMobile ? "col-md-7" : "col-7")
                                    },
                                    self.generateChosenOptionsList(cartItem.itemOptionCategories, actualItem.optionCategories),
                                    self.getItemInstructions(cartItem.itemOrderInst)
                                ),
                                _react2.default.createElement(
                                    'div',
                                    {
                                        className: 'nopadding ' + (!_this3.props.isMobile ? "col-md-5" : "col-5")
                                    },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'controls itemButtonAction w-120 mt-n1' },
                                        _react2.default.createElement(
                                            'span',
                                            { 'aria-hidden': 'true' },
                                            '['
                                        ),
                                        _react2.default.createElement(
                                            'a',
                                            { href: '#', className: "color-red cursor-pointer px-1" + " pr-1",
                                                onClick: function onClick(e) {
                                                    return self.updateItemInCart(e, index, actualItem);
                                                },
                                                tabIndex: 10
                                            },
                                            'Edit'
                                        ),
                                        _react2.default.createElement(
                                            'span',
                                            { 'aria-hidden': 'true' },
                                            '|'
                                        ),
                                        _react2.default.createElement(
                                            'a',
                                            { href: '#', className: "color-red cursor-pointer" + " px-1 pr-1",
                                                onClick: function onClick(e) {
                                                    return self.removeItemFromCart(e, index);
                                                },
                                                tabIndex: 10
                                            },
                                            'Remove'
                                        ),
                                        _react2.default.createElement(
                                            'span',
                                            { 'aria-hidden': 'true' },
                                            ']'
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        });
    },
    getItemInstructions: function getItemInstructions(itemOrderInst) {
        if (Utils.isEmpty(itemOrderInst)) {
            return null;
        }
        return _react2.default.createElement(
            'ul',
            { className: 'list-unstyled' },
            _react2.default.createElement(
                'li',
                { className: 'item-options', key: "cart-ins-list" },
                _react2.default.createElement(
                    'b',
                    null,
                    'Instructions:'
                ),
                ' ' + itemOrderInst
            )
        );
    },
    addItemsInCart: function addItemsInCart() {
        // let activeLocation = MainStore.getActiveLocation();
        // let locationObjectId = activeLocation.objectId;
        Utils.showSpinner();
        var history = this.props.history;

        var locId = this.props.params.locId;

        setTimeout(function () {
            Utils.hideSpinner();
            history.push({
                pathname: "/location/" + locId,
                resetStore: false
            });
        }, 500);
    },
    getImageLink: function getImageLink(itemObj) {
        var _this4 = this;

        if (itemObj.mediaArray && itemObj.mediaArray.length > 0) {
            var link = itemObj.mediaArray[0].url;

            getImageOrFallback(link, "no-image").then(function (result) {

                if (result == "no-image") {
                    _this4.setState({
                        imageURL: _emptyImg2.default,
                        imageAvailable: false
                    });
                } else {
                    _this4.setState({
                        imageURL: result,
                        imageAvailable: true
                    });
                }
            });
        }
    },
    setItemImage: function setItemImage(src) {
        var img = new Image();
        img.src = src;

        console.log(src);

        this.setState({
            imageURL: src,
            imageAvailable: true
        });
    },
    getItemOptionModal: function getItemOptionModal() {
        return (
            // <ItemOptionModal
            //     handleHideModal = {this.handleHideModal}
            //     title           = {this.getItemOptionModalTitle(this.state.item)}
            // >
            //     <ItemOptions
            //         item                   = {this.state.item}
            //         itemInCart             = {this.state.itemInCart}
            //         // image                  = {this.image(this.state.item)}
            //         imageURL               = {this.state.imageURL}
            //         changeTitle            = {this.changeItemOptionModalTitle}
            //         handleHideModal        = {this.handleHideModal}
            //         // showScheduleOrderModal = {this.handleShowScheduleOrderModal}
            //         // showScheduleOrderModal = {false}
            //         // isGroupAvailable       = {true}
            //     />
            // </ItemOptionModal>

            _react2.default.createElement(
                _ItemOptionModal2.default,
                {
                    handleHideModal: this.handleHideModal,
                    showModal: this.state.view.showModal,
                    image: this.state.itemImage
                    // title           = {this.getItemOptionModalTitle(this.state.itemDetailObj)}
                },
                _react2.default.createElement(_itemOptions2.default, {
                    item: this.state.item,
                    itemInCart: this.state.itemInCart,
                    imgAvailable: this.state.imageAvailable
                    // image                  = {this.image(this.state.item)}
                    , itemImageURL: this.state.imageURL,
                    changeTitle: this.changeItemOptionModalTitle,
                    handleHideModal: this.handleHideModal
                    // showScheduleOrderModal = {this.handleShowScheduleOrderModal}
                    // showScheduleOrderModal = {false}
                    // isGroupAvailable       = {true}
                })
            )
        );
    },
    handleHideModal: function handleHideModal() {
        var _this5 = this;

        this.setState({
            view: {
                showItemOptionModal: false
            }
        }, function () {
            if (!_this5.props.isMobile) {
                _this5.props.callBackParent(_this5.state.view.showItemOptionModal);
            }
        });
    },
    changeItemOptionModalTitle: function changeItemOptionModalTitle(title) {
        this.setState({
            itemOptionModalTitle: title
        });
    },
    getItemOptionModalTitle: function getItemOptionModalTitle(item) {
        var title = this.state.itemOptionModalTitle;
        return title ? title : item.groupDetailPointer.groupName;
    },
    image: function image(item, className) {
        var link = "";
        if (item.mediaArray && item.mediaArray.length > 0) {
            link = item.mediaArray[0].url;
        }
        return _react2.default.createElement('img', {
            src: link,
            title: item.itemName,
            alt: item.itemName,
            style: { width: 110, height: 110 },
            className: className
        });
    },
    render: function render() {

        return _react2.default.createElement(
            _react2.default.Fragment,
            null,
            this.state.view.showItemOptionModal ? this.getItemOptionModal() : null,
            _react2.default.createElement(
                'div',
                { className: 'bg-white mb-2' },
                _react2.default.createElement(
                    'table',
                    { className: 'table table-hover table-fixed' },
                    _react2.default.createElement(
                        'tbody',
                        null,
                        this.renderCartRow()
                    )
                )
            ),
            _react2.default.createElement(
                'div',
                { className: "bg-white mb-2 border-bottom" },
                _react2.default.createElement(_SpinButton2.default, {
                    classNames: 'btn btn-sm btn-styl rounded-sm font-weight-bold mr-2 mb-3',
                    buttonText: 'Add Item',
                    spinText: "Loading...",
                    showSpinner: false,
                    whenClicked: this.addItemsInCart,
                    showIcon: true,
                    iconClass: "icofont-plus-circle mr-1",
                    tabIndex: 11
                })
            )
        );
    }
});

var getImageOrFallback = function getImageOrFallback(path, fallback) {
    return new Promise(function (resolve) {
        var img = new Image();
        img.src = path;
        img.onload = function () {
            return resolve(path);
        };
        img.onerror = function () {
            return resolve(fallback);
        };
    });
};

//create highter order component.
var HOC_CART_ITEMS = withCartItemsRouter(CartItems);
exports.default = HOC_CART_ITEMS;


//////////////////
// WEBPACK FOOTER
// ./src/components/cart-view/CartItems.jsx
// module id = 562
// module chunks = 0